import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { MenuItems } from "./MenuItems";
import { NavLink } from "react-router-dom";
import icon from "../../images/bejour-icon.svg";

export default function Navbar() {
  const [clickState, setClick] = useState(false);
  const [clickNrState, setClickNr] = useState(0);

  const { currentUser } = useAuth();

  const handleClick = () => {
    setClick((prevClickState) => !prevClickState);
  };

  return (
    <>
      <nav className={clickState ? "nav-container active" : "nav-container"}>
        <div className="nav-items">
          <div className="nav-logo-container">
            <NavLink className="nav-link nav-logo" to="/">
              <img src={icon} alt="Bejour Icon" />
            </NavLink>
          </div>
          <div
            className="nav-menu-icon"
            onClick={() => {
              handleClick();
              setClickNr(1);
            }}
          >
            {clickState ? "Close" : "Menu"}
          </div>
          <ul
            className={
              (clickState ? "nav-menu active " : "nav-menu ") +
              (clickNrState ? "clicked" : "unclicked")
            }
          >
            {MenuItems.map((item, index) => {
              return (
                <li
                  className="nav-list-item"
                  style={
                    item.loggedOut === null ||
                    (currentUser && item.loggedOut === false) ||
                    (!currentUser && item.loggedOut === true)
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  onClick={handleClick}
                  key={index}
                >
                  <div className={item.cName}>
                    <NavLink className="nav-link nav-list-item-link" to={item.url}>
                      {item.title}
                    </NavLink>
                    <svg className="nav-svg" width="100%" height="100%">
                      <rect width="100%" height="5%" y="95%" x="0" />
                    </svg>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
      {clickState && <div className="nav-placeholder"> </div>}
    </>
  );
}
